import { connectRoutes } from "redux-first-router";
import querystring from "query-string";

import { injectThunks, RoutesMapWithLazyThunk } from "../router-thunks/injectThunks";

function getBasename(): string {
  if (process.env.NODE_ENV === "development") {
    return;
  }

  const [, basename] = location.pathname.split("/");

  return basename;
}

export const createReduxRouter = (routing: RoutesMapWithLazyThunk) => {
  return connectRoutes(injectThunks(routing), {
    basename: getBasename(),
    querySerializer: querystring,
  });
};
